import React from 'react';

import PropTypes from 'prop-types';

function RouteOverviewTruncationItem({ nodeDatum, toggleNode, onNodeClick, onNodeMouseOver, onNodeMouseOut, focusableNodes }) {
  return (
    <text
      className="route-overview-tree-truncation-item"
      onClick={(event) => {
        toggleNode();
        onNodeClick(event, nodeDatum);
      }}
      onKeyPress={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleNode();
          onNodeClick(event, nodeDatum);
        }
      }}
      onMouseOver={onNodeMouseOver}
      onMouseOut={onNodeMouseOut}
      tabIndex={focusableNodes ? 0 : -1}
      x={-24}
      y={3}>
      [&#183;&#183;&#183;]
    </text>
  );
}

RouteOverviewTruncationItem.propTypes = {
  nodeDatum: PropTypes.any,
  toggleNode: PropTypes.func,
  onNodeClick: PropTypes.func,
  onNodeMouseOver: PropTypes.func,
  onNodeMouseOut: PropTypes.func,
  focusableNodes: PropTypes.bool,
};

RouteOverviewTruncationItem.defaultProps = {
  toggleNode: () => null,
  onNodeClick: () => null,
  onNodeMouseOver: () => null,
  onNodeMouseOut: () => null,
  focusableNodes: true,
};

export default RouteOverviewTruncationItem;
